import { SET_MONEY, FETCH_PAYMENT_OPTIONS, RESET_PAYMENT, SET_PAYMENT_OPTIONS } from './constants';

export const setMoney = (data: any) => ({
  type: SET_MONEY,
  data,
});

export const fetchPaymentOptions = (payload: any) => {
  const { mId, orderId, token } = payload;
  const requestParams: any = {};
  requestParams['query'] = `mid=${mId}&orderId=${orderId}`;
  requestParams['params'] = {
    head: {
      channelId: 'WAP',
      txnToken: token,
    },
    channelId: 'WAP',
  };
  return {
    type: FETCH_PAYMENT_OPTIONS,
    data: requestParams,
  };
};

export const resetPayment = () => ({
  type: RESET_PAYMENT,
});

export const setPaymentOptions = (data: any) => ({
  type: SET_PAYMENT_OPTIONS,
  data,
});
